import { Navigate, useLocation } from "react-router-dom";
import { useSub } from "../../../common/subscription/useSub";
import { urls } from "../../../urls";
import { OrganizationsPage } from "./OrganizationsPage";

export const OrganizationsRoute = () => {
  const sub = useSub();
  const location = useLocation();

  if (sub.hasSourcingEventV2Access) {
    return <Navigate to={`${urls.v2.organizations}${location.search}${location.hash}`} replace />;
  }

  return <OrganizationsPage />;
};
